
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/newsletter",
      function () {
        return require("private-next-pages/en/newsletter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/newsletter"])
      });
    }
  